import React, { useState, useEffect } from 'react';
import grapesjs from 'grapesjs';
import gjsPresetWebpage from 'grapesjs-preset-webpage';
import 'grapesjs/dist/css/grapes.min.css';
import '../assets/css/builder.scss';

function Builder() {
    const [editor, setEditor] = useState(null);
    useEffect(()=> {
        const editor = grapesjs.init({
            container: "#editor",
            plugins: [gjsPresetWebpage],
            pluginsOpts: {
                gjsPresetWebpage
            }
        });
        setEditor(editor);
    }, []);
	console.log(editor)
	editor.addComponents(`<div>
	  <img src="https://cdn4.buysellads.net/uu/1/41334/1550855401-cc_light.png" />
	  <span title="foo">Hello world!!!</span>
	</div>`);
    return (
      <div id="editor">
			
      </div>
    );
}

export default Builder
